import React, { FC } from "react";
import { useContext } from "./useContext";
import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";

export const SaveQLSLayer: FC = () => {
  const context = useContext();

  return <SimpleDialogFallback context={{ maxWidth: "56.25rem", title: context.title.text as string }} />;
};
